import Login from './containers/Login';

export default Login;



// WEBPACK FOOTER //
// ./src/scenes/Login/index.tsx